import { render, staticRenderFns } from "./TagMetadataComponent.vue?vue&type=template&id=28c0a878&scoped=true"
import script from "./TagMetadataComponent.vue?vue&type=script&lang=js"
export * from "./TagMetadataComponent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TagMetadataComponent.vue?vue&type=style&index=1&id=28c0a878&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c0a878",
  null
  
)

export default component.exports